import styled from 'styled-components'
import { media } from 'styles/media'

import ButtonLink from 'components/display/ButtonLink'
import { SectionTitle, HeadingXxl } from 'components/display/Typography'
import Camping from 'components/icons/CampingDetailed'
import MapDetailed from 'components/icons/MapDetailed'
import Telescope from 'components/icons/TelescopeDetailed'
import {
  IllustratedParagraph,
  Wrapper as IllustratedParagraphsWrapper,
} from '../../IllustratedParagraph'
import { ButtonWrapper } from '../styles'

const Heading = styled(HeadingXxl)`
  ${media.md`
    max-width: 850px;
    margin: 0 auto;
  `}
`

const Booking = () => {
  return (
    <>
      <SectionTitle centered>Booking</SectionTitle>
      <Heading centered>
        Every new adventure begins with a dream of achieving a fulfilling moment
      </Heading>

      <IllustratedParagraphsWrapper>
        <IllustratedParagraph
          heading="Get inspired"
          text="Start your Riparide journey by browsing our listings and Stories. Listings contain unique accommodation and experiences, while Stories are visual itineraries associated with a featured listing."
          icon={<Telescope />}
          centered
        />
        <IllustratedParagraph
          heading="Make a booking"
          text="Ready to experience an escape for yourself? Send a booking request to the host. They have 24 hours to accept or decline your request. Payment is taken once the booking is accepted."
          icon={<MapDetailed />}
          centered
        />
        <IllustratedParagraph
          heading="Have an epic adventure"
          text="Pack your bags and your adventurous spirit! Take a look at the adventure suggestions, and check in with your host regarding house rules and instructions."
          icon={<Camping />}
          centered
        />
      </IllustratedParagraphsWrapper>

      <ButtonWrapper>
        <ButtonLink href="/listings" compact uppercase={false}>
          Book an escape
        </ButtonLink>
        <ButtonLink href="/stories-travellers" compact ghost uppercase={false}>
          Learn more about Stories
        </ButtonLink>
      </ButtonWrapper>
    </>
  )
}

export default Booking
